import { BoxProps } from '@material-ui/core'

export enum Corner {
  TopLeft,
  TopRight,
  BottomRight,
  BottomLeft,
  MiddleLeft,
  MiddleRight
}

export interface IProps extends BoxProps {
  corner?: Corner
  bgColor?: string
  size?: number
  shadow?: boolean
  borderRadius?: string
}
